module.exports = __webpack_public_path__ + "img/styles_background_mobile@2x.36501a1.webp";